import React from "react";
import {
  SubmitContainer,
  UploadArea,
  UploadInfo,
  IconWrapper,
  UploadText,
  Divider,
  DividerLine,
  DividerText,
  MobileButtonGroup
} from "./practice-submit.styles";
import { Button } from "design-system/components/button/button";
import { ButtonSize } from "design-system/components/button/button.types";
import { Icon } from "design-system/components/icon/icon";

interface PracticeSubmitProps {
  onOpenCamera: () => void;
  onPickFile: () => void;
  onClose: () => void;
}

export const PracticeSubmit: React.FC<PracticeSubmitProps> = ({
  onOpenCamera,
  onPickFile,
  onClose
}) => {
  return (
    <SubmitContainer>
      <UploadArea>
        <UploadInfo>
          <IconWrapper>
            <Icon name="general-camera" />
          </IconWrapper>
          <UploadText>
            Pastikan foto jawaban kamu berada pada area kamera ya..
          </UploadText>
        </UploadInfo>
        <Button
          appearance="general"
          variant="secondary"
          size={ButtonSize.lg}
          onClick={onOpenCamera}
        >
          Buka Kamera
        </Button>
      </UploadArea>

      <Divider>
        <DividerLine />
        <DividerText>atau</DividerText>
        <DividerLine />
      </Divider>

      <UploadArea>
        <UploadInfo>
          <IconWrapper>
            <Icon name="general-file" />
          </IconWrapper>
          <UploadText>
            Pilih file jawaban kamu dengan format: JPEG, JPG, PNG
          </UploadText>
        </UploadInfo>
        <Button
          appearance="general"
          variant="secondary"
          size={ButtonSize.lg}
          onClick={onPickFile}
        >
          Cari File Disini
        </Button>
      </UploadArea>

      <MobileButtonGroup>
        <Button
          appearance="general"
          variant="primary"
          size={ButtonSize.lg}
          isFullWidth
          onClick={onClose}
        >
          Kembali
        </Button>
      </MobileButtonGroup>
    </SubmitContainer>
  );
};
